import React from "react";
import "./../../styles/places.css";
import { Container, Row, Col } from "reactstrap";
import tour1 from "./../../assets/images/karauli.jpg";
import Newsletter from "../../shared/Newsletter";

const Karauli = () => {
  return (
    <>
      <div className="center-content">
        <h1 className="centered-title text-3xl font-bold mt-6 mb-4">Karauli</h1>
        <section>
          <Container>
            <Row>
              <Col lg="12">
                <div className="details__container mx-auto">
                  <div className="mb-4 ">
                    <h2
                      className="text-xl font-semibold"
                      style={{ textAlign: "left" }}
                    >
                      Destinations Covered:
                    </h2>
                    <ul className="list-disc pl-4">
                      <li>Bhanwar Vilas Palace</li>
                      <li>City Palace-Karauli</li>
                      <li>Kaila Devi Fair</li>
                      <li>Temples of Madan Mohan Ji and Kalyan Ji</li>
                      <li>Bharatpur Bird Sanctuary</li>
                      <li>Ranthambore National Park</li>
                      <li>Kaila Devi Game Sanctuary</li>
                      <li>Mahaveerji Jain Temple</li>
                    </ul>
                  </div>

                  <h2
                    className="text-xl font-semibold"
                    style={{ textAlign: "left" }}
                  >
                    About Karauli
                  </h2>
                  <Col lg="6">
                    <div className="wrapingimage">
                      <img src={tour1} alt="" />
                    </div>
                  </Col>
                  <p>
                    The holy city of Karauli is located at a distance of 160 kms
                    from the capital city of Jaipur. The city of Karauli was
                    earlier known as Kalyanpuri, the name given after the local
                    deity Kalyanji. The city of Karauli was established keeping
                    in mind the danger of frequent attacks. Therefore the city
                    was fully equipped with arms and was surrounded by a wall
                    made up of red sandstone with citadels at various places.
                    The surrounding wall of the city has 6 gates and eleven
                    posterns. Karauli- History and Legends Raja Arjun Pal
                    founded the city of Karauli, earlier known as Kalyanpuri in
                    1348 AD. It is believed that Yaduvanshi Rajputs who are
                    descendents of Lord Krishna ruled the city of Karauli, one
                    of the most loved gods of Hindu mythology. As such they
                    occupy the topmost rank among the Yaduvanshi Rajputs and
                    their family history is rich with tales of valor and glory.
                    Karauli was an erstwhile princely state in eastern
                    Rajasthan.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left", color: "#ee6e6e" }}
                  >
                    Places to Visit in Karauli
                  </h2>

                  <p>
                    The city of Karauli that is famous for its pale red
                    sandstone is also famous as a holy place. One could see many
                    old monuments, explore the rural way of life and visit the
                    Kaila Devi game sanctuary during his tour to Karauli. The
                    most famous attractions of the city of Karauli are Bhanwar
                    Vilas Palace, City Palace- Karauli, Kaila Devi Fair, Temples
                    of Madan Mohan Ji and Kalyan Ji.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Bhanwar Vilas Palace
                  </h2>
                  <p>
                    The then ruler Maharaja Ganesh Pal Deo Bahadur constructed
                    the Bhanwar Vilas Palace in the year 1938. The palace built
                    for the royal family to stay in has majestic architecture
                    and antique furnishings.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    City Palace-Karauli
                  </h2>
                  <p>
                    The old monument of City Palace is exemplary in
                    architecture, stone carvings and paintings. To witness the
                    exquisite beauty of the Darbar Hall is a lifetime experience
                    for the visitors.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Kaila Devi Fair
                  </h2>
                  <p>
                    The fair is held in the Chaitra month on Chaitra Budi 12 and
                    lasts for a fortnight every year. This fair is held in the
                    honour of Kaila Devi or Mahalakshmi and holds a special
                    place in the hearts of devotees who attend this fair at
                    Kaila village every year.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Temples of Madan Mohan Ji and Kalyan Ji
                  </h2>
                  <p>
                    The ancient temples of Madan Mohan Ji and Kalyan Ji are
                    visited by thousands of devotees every year. The city is
                    also said to be home of Shri Madan Mohan Ji.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Bharatpur Bird Sanctuary
                  </h2>
                  <p>
                    The Bharatpur Bird Sanctuary that was once a favorite
                    hunting place for the princes of Bharatpur has now been
                    accepted as a world heritage and houses more than 350
                    different species of birds. This sanctuary is at a distance
                    of 110 kms from the city of Karauli.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Ranthambore National Park
                  </h2>
                  <p>
                    Maharaja of Jaipur earlier frequented this park as it used
                    to be the hunting ground for the ruler of Jaipur. Earlier in
                    1955, it was granted the status of game sanctuary while it
                    became a national park in the year 1980. The place famous
                    for tigers is also at a distance of 110 kms from Karauli.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Kaila Devi Game Sanctuary
                  </h2>
                  <p>
                    The Mahaveerji Jain Temple is a famous pilgrimage of the
                    Jain community and is frequented by thousands of devotees
                    every year.
                  </p>

                  <h2
                    className="text-xl font-semibold "
                    style={{ textAlign: "left" }}
                  >
                    Mahaveerji Jain Temple
                  </h2>
                  <p>
                    The game sanctuary situated adjacent to the city of Karauli
                    is a extension of Ranthambore tiger project. This sanctuary
                    is famous for species like Chinkaras, Wild Boar, Blue Bull,
                    Jackal, Leopard, Panther, Tiger, Sloth Bear, Hyena, Wolf,
                    Sambhar and a variety of birds. This sanctuary is located at
                    a distance of 25 kms from Karauli.
                  </p>
                </div>
              </Col>
              <Col lg="4">
                {/* Add a newsletter component or other content in the right column */}
              </Col>
            </Row>
          </Container>
        </section>
      </div>
      <Newsletter />
    </>
  );
};

export default Karauli;
